import React from 'react';
import { Tree } from '@myua/kit';
import { ArrowDown } from '@myua/icons/dist/linear14';
import { useSelector, useDispatch } from 'react-redux';
import {
  getTreeData,
  getSelectedKeys,
  getExpandedKeys,
  getLoading,
  getCategories,
  getCategoriesById,
} from '../selectors';
import { TreeSkeleton } from '../../skeleton/components/Skeleton';
import * as categoryActions from '../actions';
import { Category } from '../../../api';
import { ALL_CATEGORIES_ID } from '../model';
import { useHistory } from 'react-router-dom';
import { getPage } from '../../router/selectors';
import { routes, Page } from '../../router/model';

export const Categories = () => {
  const dispatch = useDispatch();
  const treeData = useSelector(getTreeData);
  const selectedKeys = useSelector(getSelectedKeys);
  const expandedKeys = useSelector(getExpandedKeys);
  const loading = useSelector(getLoading);
  const categories = useSelector(getCategories);
  const page = useSelector(getPage);
  const history = useHistory();
  const categoriesById = useSelector(getCategoriesById);

  const select = (id: Category['id']) => {
    dispatch(
      categoryActions.categorySelected({
        id,
        saveLastState: true,
        log: { category: categoriesById[id] || null },
      }),
    );
    if (page !== Page.viewer) {
      history.push(routes.viewer);
    }
  };

  // Скелетон только когда показывать нечего. Если дерево пришло из кэша (мгновенная
  // навигация) или уже загружено, фоновое обновление проходит незаметно.
  if (loading && categories.length === 0) {
    return (
      // Скелетоны для скринридера скрыты (aria-hidden), поэтому о загрузке сообщает
      // сама область — раньше эту роль неявно выполнял <Spin>.
      <div className="al-categories" aria-busy>
        <TreeSkeleton rows={7} />
      </div>
    );
  }

  return (
    <div className="al-categories">
      <div className="al-fade-in">
        <Tree
          className="al-app-sider-tree"
          switcherIcon={<ArrowDown />}
          treeData={treeData}
          // Если expandedKeys обновились до появления их в treeData, то Ant воспримет их,
          // только если это будет новый объект. Такое происходит при загрузке lastState.
          expandedKeys={[...expandedKeys]}
          selectedKeys={selectedKeys}
          onSelect={(ids) => {
            if (ids.length === 0 && !selectedKeys.includes(ALL_CATEGORIES_ID)) {
              select(ALL_CATEGORIES_ID);
            } else if (ids.length > 0) {
              const id = ids[0] as Category['id'];
              select(id);
            }
          }}
          onExpand={(keys) =>
            dispatch(
              categoryActions.setExpandedKeys({
                keys: keys as Category['id'][],
                saveLastState: true,
              }),
            )
          }
        />
      </div>
    </div>
  );
};
